module.exports = __webpack_public_path__ + "static/media/15UN-Habitat2.5c2293ea.jpg";